import { combineReducers } from 'redux';
import * as loginReducer from './component/login/reducer';
import * as commonReducer from './component/common/reducer';

export default combineReducers(Object.assign( loginReducer, commonReducer ));